"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NotificationSync = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

var _knotchincWebReactComponentsUtils = require("@bit/knotchinc.web-react-components.utils.utils");

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.list-sync"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.click-outside"));

var _knotchincWebReactComponents3 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _ifvisible = _interopRequireDefault(require("ifvisible.js"));

var _styled = require("./styled");

var _NewAlerts = _interopRequireDefault(require("./NewAlerts"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NOTIFICATION_FETCH_INTERVAL = 30000;

var NotificationSync = /*#__PURE__*/function (_Component) {
  _inherits(NotificationSync, _Component);

  var _super = _createSuper(NotificationSync);

  function NotificationSync(props) {
    var _this;

    _classCallCheck(this, NotificationSync);

    _this = _super.call(this, props);
    _this.scrollNode = undefined;
    _this.poll = setInterval(function () {
      return _this.fetchData();
    }, NOTIFICATION_FETCH_INTERVAL);
    _this.state = {
      isOpen: false,
      bellCount: 0,
      popUpAlerts: [],
      exposedAlerts: {},
      firstFetched: false
    };

    _ifvisible["default"].on('blur', function () {
      clearInterval(_this.poll);
    });

    _ifvisible["default"].on('focus', function () {
      clearInterval(_this.poll);
      _this.poll = setInterval(function () {
        return _this.fetchData();
      }, NOTIFICATION_FETCH_INTERVAL);
    });

    return _this;
  }

  _createClass(NotificationSync, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var markPageAsSeen = this.props.markPageAsSeen;
      var queryParams = (0, _knotchincWebReactComponentsUtils.toQueryObject)(window.location.search);

      if (queryParams && queryParams.mark_as_seen) {
        markPageAsSeen(queryParams.mark_as_seen);
      }

      this.fetchData();
    }
    /**
     *
     * @param {} prevProps
     * Unseen alerts - Alerts that have not been viewed in the dropdown menu yet,
     * and will be displayed in the count on the top right under the bell
     *
     * New alerts - Alerts that have come in since the user's session started,
     * that will be added at the bottom right of the screen
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$state = this.state,
          bellCount = _this$state.bellCount,
          exposedAlerts = _this$state.exposedAlerts,
          firstFetched = _this$state.firstFetched;
      var oldData = prevProps.listStore.data;
      var _this$props$listStore = this.props.listStore,
          currentData = _this$props$listStore.data,
          fetched = _this$props$listStore.fetched;

      var hasBeenExposed = function hasBeenExposed(_ref) {
        var public_id = _ref.public_id;
        return exposedAlerts[public_id];
      };

      var newUnseenAlertsIds = currentData.filter(function (alert) {
        return !hasBeenExposed(alert) && !alert.seen_at;
      });

      if (bellCount !== newUnseenAlertsIds.length) {
        this.setState({
          bellCount: newUnseenAlertsIds.length
        });
      } // New Alerts


      var oldIds = oldData.map(function (alert) {
        return alert.public_id;
      });
      var popUpAlerts = currentData.filter(function (alert) {
        return oldIds.indexOf(alert.public_id) === -1 && !alert.seen_at;
      });

      if (firstFetched && popUpAlerts.length) {
        this.setState({
          popUpAlerts: popUpAlerts
        });
      }

      if (!firstFetched && fetched) {
        this.setState({
          firstFetched: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.poll);
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this$props = this.props,
          clear = _this$props.listStore.clear,
          fetch = _this$props.fetch;
      var isOpen = this.state.isOpen;

      if (!isOpen) {
        if (this.request && this.request.abort) this.request.abort();
        this.request = fetch(clear);
      }
    }
  }, {
    key: "closeNewAlert",
    value: function closeNewAlert(alertId) {
      var popUpAlerts = this.state.popUpAlerts.filter(function (alert) {
        return alert.public_id !== alertId;
      });
      this.setState({
        popUpAlerts: popUpAlerts
      });
    }
    /**
     * On opening notification dropdown, all alerts have been percieved
     */

  }, {
    key: "openNotifications",
    value: function openNotifications() {
      var exposedAlerts = this.state.exposedAlerts;
      var data = this.props.listStore.data;

      var newExposedAlerts = _objectSpread({}, exposedAlerts);

      data.map(function (alert) {
        if (!newExposedAlerts[alert.public_id]) {
          newExposedAlerts[alert.public_id] = 1;
        }
      });
      this.setState({
        isOpen: true,
        popUpAlerts: [],
        exposedAlerts: newExposedAlerts
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          popUpAlerts = _this$state2.popUpAlerts,
          bellCount = _this$state2.bellCount,
          renderBottomAlerts = _this$state2.renderBottomAlerts;
      var _this$props2 = this.props,
          children = _this$props2.children,
          listStore = _this$props2.listStore,
          _fetch = _this$props2.fetch,
          actionType = _this$props2.actionType,
          clearAllAlerts = _this$props2.clearAllAlerts;
      var data = listStore.data;
      var ListElement = children.type;
      var unseenAlerts = data.filter(function (alert) {
        return !alert.seen_at;
      });
      var notificationSyncContainer = null;

      if (this._scrollContainerRef) {
        notificationSyncContainer = this._scrollContainerRef._container;
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_NewAlerts["default"], {
        closeAlert: function closeAlert(alertId) {
          return _this2.closeNewAlert(alertId);
        },
        alerts: popUpAlerts,
        AlertComponent: ListElement,
        openNotifications: function openNotifications() {
          return _this2.openNotifications();
        },
        renderBottomAlerts: renderBottomAlerts
      }), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], {
        close: function close() {
          return _this2.setState({
            isOpen: false
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_styled.NotificationButton, {
        onClick: function onClick() {
          return _this2.openNotifications();
        }
      }), bellCount > 0 ? /*#__PURE__*/_react["default"].createElement(_styled.UnseenAlertsBadge, {
        onClick: function onClick() {
          return _this2.openNotifications();
        }
      }, bellCount > 99 ? '99+' : bellCount) : null, this.state.isOpen && /*#__PURE__*/_react["default"].createElement(_styled.NotificationsContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.InnerContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.NotificationsTitle, null, "Notifications"), /*#__PURE__*/_react["default"].createElement(_styled.CloseButton, {
        onClick: function onClick() {
          return _this2.setState({
            isOpen: false
          });
        }
      }, "\u2715"), unseenAlerts.length > 0 ? /*#__PURE__*/_react["default"].createElement(_styled.ClearAllButton, {
        onClick: function onClick() {
          return clearAllAlerts();
        }
      }, "Mark All as Seen") : null, data.length ? /*#__PURE__*/_react["default"].createElement(_styled.ScrollContainer, null, /*#__PURE__*/_react["default"].createElement(_reactPerfectScrollbar["default"], {
        ref: function ref(el) {
          _this2._scrollContainerRef = el;
        }
      }, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
        listStore: listStore,
        fetch: function fetch(clear) {
          return _fetch(clear);
        },
        actionType: actionType,
        loadOnScroll: true,
        container: notificationSyncContainer
      }, /*#__PURE__*/_react["default"].createElement(ListElement, {
        closeMenu: function closeMenu() {
          return _this2.setState({
            isOpen: false
          });
        },
        showOptions: true,
        style: {
          width: '100%'
        }
      })))) : /*#__PURE__*/_react["default"].createElement(_styled.EmptyNotificationsView, null, /*#__PURE__*/_react["default"].createElement(_styled.EmptyNotificationsEmoji, null), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents3["default"], {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#323848",
        mb: "9px"
      }, "You're all caught up!"), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents3["default"], {
        fontSize: "11px",
        lineHeight: "15px",
        color: "#939AAB"
      }, "Look at you, you content specialist you."))))));
    }
  }]);

  return NotificationSync;
}(_react.Component);

exports.NotificationSync = NotificationSync;
NotificationSync.defaultProps = {
  listStore: {
    data: [],
    fetched: false,
    fetching: false,
    status: null,
    filters: {}
  }
};
var _default = NotificationSync;
exports["default"] = _default;

//# sourceMappingURL=NotificationSync.js.map